import { Component, OnInit, Inject, LOCALE_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'gl-balance-page',
    templateUrl: './balance-page.component.html',
    styleUrls: ['./balance-page.component.css']
})
export class BalancePageComponent implements OnInit {
    constructor(
        @Inject(LOCALE_ID) public locale: string,
        private translate: TranslateService
    ) {}

    ngOnInit() {
        this.locale = this.translate.currentLang;
    }
}
